import { render, staticRenderFns } from "./EditCustomerInfo.vue?vue&type=template&id=650d1483&lang=pug&"
import script from "./EditCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./EditCustomerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports